import { Link, useLoaderData, useRouteError } from "react-router-dom";
import GenericErrorDisplay from "../generic-error";
import TransmedProcessService from "../../service/transmed/process";
import OutputTransmedEdition, {
  TransmedEditionSeason,
} from "../../dtos/transmed/process/edition";
import subtractOneSecond from "../../utils/subtractOneSecond";
import TransmedReceivingService from "../../service/transmed/process/receiving";
import TransmedReceiving from "../../dtos/transmed/process/receiving";
import useAuth from "../../auth/hooks";
import { externalRedirectUrl } from "../page-redirect";
import { IMAGE_HOST } from "../../server/config";

export const path = "transmed/calendar";

export async function loader() {
  const edition = await new TransmedProcessService().read.edition();
  let receivings = null;
  if (edition.process_started)
    receivings = await new TransmedReceivingService().read.all();
  return [edition, receivings];
}

export function Component() {
  const [edition, receivings] = useLoaderData() as [
    OutputTransmedEdition,
    TransmedReceiving[] | null
  ];

  const auth = useAuth();
  const receiving =
    receivings?.find((r) => {
      return r.lc.id === auth?.lc?.id;
    }) ?? null;

  return (
    <>
      <h1 style={{ marginBottom: "var(--gap-big)", wordBreak: "break-word" }}>
        Informații ediție transmed
      </h1>
      {receiving === null ? (
        receivings === null ? (
          <span>Transmed nu a început încă</span>
        ) : (
          <span>Centrul tău nu organizează transmed această ediție.</span>
        )
      ) : (
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "1fr 1fr",
            gap: "var(--gap-medium)",
            wordBreak: "break-word",
          }}
        >
          <b>Anul</b>
          <span>{edition.year}</span>
          <b>Sezonul</b>
          <span>
            {edition.season === TransmedEditionSeason.autumn
              ? "Toamnă-Iarnă"
              : "Primăvară"}
          </span>
          <b>Perioada în cuvinte</b>
          <span>{edition.period_text}</span>
          <b>Start înscrieri</b>
          <span>
            {edition.registration_start.toLocaleDateString("RO-ro")}, ora{" "}
            {edition.registration_start.toLocaleTimeString("RO-ro")}
          </span>
          <b>Stop înscrieri</b>
          <span>
            {subtractOneSecond(edition.registration_end).toLocaleDateString(
              "RO-ro"
            )}
            , ora{" "}
            {subtractOneSecond(edition.registration_end).toLocaleTimeString(
              "RO-ro"
            )}
          </span>
          <b>Clasament provizoriu</b>
          <span>
            {edition.points_deadline_first.toLocaleDateString("RO-ro")}, ora{" "}
            {edition.points_deadline_first.toLocaleTimeString("RO-ro")}
          </span>
          <b>Termen contestații</b>
          <span>
            {subtractOneSecond(edition.contesting_deadline).toLocaleDateString(
              "RO-ro"
            )}
            , ora{" "}
            {subtractOneSecond(edition.contesting_deadline).toLocaleTimeString(
              "RO-ro"
            )}
          </span>
          <b>Clasament final</b>
          <span>
            {edition.points_deadline_second.toLocaleDateString("RO-ro")}, ora{" "}
            {edition.points_deadline_second.toLocaleTimeString("RO-ro")}
          </span>
          <b>Start distribuție</b>
          <span>
            {edition.distribution_start.toLocaleDateString("RO-ro")}, ora 09:00
          </span>
          <b>Start transmed</b>
          <span>{receiving.exchange_start.toLocaleDateString("RO-ro")}</span>
          <b>Final transmed</b>
          <span>{receiving.exchange_end.toLocaleDateString("RO-ro")}</span>
          <b>Termen încărcare adeverințe</b>
          <span>
            {subtractOneSecond(
              edition.participation_proof_deadline
            ).toLocaleDateString("RO-ro")}
            , ora{" "}
            {subtractOneSecond(
              edition.participation_proof_deadline
            ).toLocaleTimeString("RO-ro")}
          </span>
          <b>Regulament</b>
          <Link
            style={{ margin: "calc(0px - var(--gap-small)) 0" }}
            to={externalRedirectUrl(IMAGE_HOST + edition.regulations)}
            className="primary button text"
          >
            Regulament
          </Link>
          <b>Model adeverință</b>
          <Link
            style={{ margin: "calc(0px - var(--gap-small)) 0" }}
            to={externalRedirectUrl(
              IMAGE_HOST + edition.participation_proof_template
            )}
            className="primary button text"
          >
            Adeverință
          </Link>
        </div>
      )}
    </>
  );
}
Component.displayName = "page-account-transmed-calendar";

export function ErrorBoundary() {
  const error = useRouteError();
  return <GenericErrorDisplay error={error} />;
}
ErrorBoundary.displayName = "page-account-transmed-calendar-error";
